// extracted by mini-css-extract-plugin
module.exports = {"volumeBarWrapper":"VolumeBar_volumeBarWrapper__3Vo9R","volumeBar":"VolumeBar_volumeBar__2Nk3r","volumeIcon":"VolumeBar_volumeIcon__17qvo"};